/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Layout_BoardInputs */

const en_layout_board = /** @type {(inputs: Layout_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

const de_layout_board = /** @type {(inputs: Layout_BoardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Board`)
};

/**
* | output |
* | --- |
* | "Board" |
*
* @param {Layout_BoardInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const layout_board = /** @type {((inputs?: Layout_BoardInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Layout_BoardInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_layout_board(inputs)
	return en_layout_board(inputs)
});